import { createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { appConfig } from './app/app.config';
import { ZpetnaVazba } from './app/zpetna-vazba/zpetna-vazba';
import { Grid } from './app/grid/grid';

(async () => {
  // 1. Nastartujeme Angular aplikaci bez vykreslení do DOMu
  // (to nám umožní používat Dependency Injection, HttpClient atd.)
  const app = await createApplication(appConfig);

  // 2. Zabalíme naši Angular komponentu do Web Componenty
  const zpetnaVazbaElement = createCustomElement(ZpetnaVazba, {
    injector: app.injector
  });
  const customGridElement = createCustomElement(Grid, {
    injector: app.injector
  });

  // 3. Zaregistrujeme nový tag do prohlížeče
  // Odteď prohlížeč ví, co má dělat, když uvidí <app-zpetna-vazba>
  customElements.define('app-zpetna-vazba', zpetnaVazbaElement);
  customElements.define('app-grid', customGridElement);
})();

declare global {
  interface Window {
    custom: {
      l10n: {
        localize: (key: string) => string;
      },
      forms: {
        opened: (data: string) => void;
      },
      utils: {
        toast:  (text: string, type: 'success' | 'warning', timer: number) => void;
      }
    }
  }
};
